import BaseService from './base.service';

const baseService = new BaseService('coursegrade');

export default {
  findAllByCountry: (countryId: number | string) => baseService.get(`findAll/${countryId}`),
};
